export var GeometryUpdaterFactory = 'GeometryUpdaterFactory';
export var GeometryAABBUpdater = 'GeometryAABBUpdater';